import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DropdownButton from "react-bootstrap/DropdownButton";
import defaultcover from "../../assets/icons/default-cover.png";
import Dropdown from "react-bootstrap/Dropdown";
import GetAccount from "../../actions/GetAccount";
import { AuthContext } from "../../context/AuthContext";
import Localbase from "localbase";
import CoverPictureEdit from "./CoverPictureEdit";
import DpChange from "./DpChange";

import Box from "@mui/material/Box";

import Logout from "../authentication/Logout";

import GetPublicAccount from "../../actions/GetPublicAccount";
import PublicDpChange from "./PublicDpChange";
const PublicUserAccount = () => {
  let db = new Localbase("db");

  const params = useParams();
  const username = params.username;
  const [account, setaccount] = useState(null);
  const { user } = useContext(AuthContext);
  const NewGetAccount = async () => {
    const res = await GetPublicAccount({
      payload: { user: user, username: username },
    });
    if (res) {
      if (res.status === "success" && res.data !== null) {
        setaccount(res.data);
      }
    }
  };

  useEffect(() => {
    NewGetAccount();
  }, [user]);

  const [dp, setdp] = useState(null);

  const [stats, setstats] = useState(null);
  const [statsdisplay, setstatsdisplay] = useState(false);
  const [croppedimage, setcroppedimage] = useState(null);

  const [logoutmodal, setlogoutmodal] = useState(false);

  const InstanceLogout = async ({ payload }) => {
    const res = await Logout({ payload });
    if (res) {
      //  //console.log("log instance"+JSON.stringify(res))
    }
  };

  return (
    <>
      {account ? (
        <>
          <div className="w-100 profile sm-shadow-none sm-border-none br-5 lg-mt-4 mt-3">

            <style>{`
.carousel-container {
  width: 100%;
  height: 300px;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: #f8f9fa;
}

.profile-container {
  position: relative;
  margin-top: -80px;
  padding: 1.5rem;
  background: #ffffff;
  border-radius: 0 0 12px 12px;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: nowrap;
  z-index: 20;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.profile-avatar-section {
  flex-shrink: 0;
}

.profile-info-section {
  flex: 1;
}

.profile-info-section h4 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
}

.profile-info-section .username {
  color: #666;
  font-size: 0.9rem;
}

.profile-stats {
  display: flex;
  gap: 1.5rem;
  margin-top: 0.6rem;
}

.profile-stats div {
  text-align: center;
}

.profile-stats h6 {
  margin: 0;
  font-weight: 600;
}

.profile-stats p {
  margin: 0;
  font-size: 0.8rem;
  color: #777;
}
`}</style>

            {/* Banner */}
            <div className="carousel-container">
              <img
                src={account.cover_pic ? account.cover_pic : defaultcover}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            </div>

            {/* Profile Section */}
            <div className="profile-container">

              {/* Avatar */}
              <div className="profile-avatar-section">
                <PublicDpChange account={account} />
              </div>

              {/* Info */}
              <div className="profile-info-section">

                <Link to={"/u/" + account.username} className="text-decoration-none text-dark">
                  <h4>
                    {[account.first_name, account.last_name].filter(Boolean).join(" ") || "Unknown User"}
                  </h4>
                </Link>

                <div className="username">
                  @{account.username}
                </div>

                {/* Stats */}
                <div className="profile-stats">

                  <Link to={"/u/" + username + "/posts"}>
                    <h6>{account.posts}</h6>
                    <p>Posts</p>
                  </Link>

                  <Link to={"/u/" + username + "/following"}>
                    <h6>{account.following}</h6>
                    <p>Following</p>
                  </Link>

                  <Link to={"/u/" + username + "/followers"}>
                    <h6>{account.followers}</h6>
                    <p>Followers</p>
                  </Link>

                </div>

              </div>

            </div>
          </div>

        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default PublicUserAccount;